export default __webpack_public_path__ + "static/media/eight.80c313e3.jpg";